<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="invoicemethod_no" [ttModel]="edit.invoicemethod_no" ttReadonly></tt-input>
        <tt-input ttLabel="invoicemethod_name" [ttModel]="edit.invoicemethod_name" [ttButtons]="invoiceMethodNameButtons" ttReadonly></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="invoicemethod_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="invoicemethod_no" tt-model="vm.model.edit.invoicemethod_no" tt-change="vm.model.edit.invoicemethod_no = $value" tt-readonly="true"></tt-input>
        <tt-input-buttons class="col-xs-12 sp-0" tt-label="invoicemethod_name" tt-model="vm.model.edit.invoicemethod_name" tt-change="vm.model.edit.invoicemethod_name = $value" tt-placeholder="" tt-buttons="vm.model.invoiceMethodNameButtons" tt-readonly="true"></tt-input-buttons>
        <tt-checkbox class="col-xs-12 sp-0" tt-label="isactive" tt-model="vm.model.edit.isactive" tt-change="vm.model.edit.isactive = $value"></tt-checkbox>
        <tt-button-save class="col-xs-12 sp-0" tt-text="invoicemethod_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
